<template>
  <div>
    <span
      v-for="(req, idx) in data.split(/;|；/)"
      :key="idx"
    >
      <span v-if="req !== ''">
        <span v-if="req.indexOf('/') === -1" style="display: inline-block">
          {{
            ["①", "②", "③", "④", "⑤", "⑥", "⑦", "⑧", "⑨", "⑩", "⑪", "⑫"][idx] +
              req.replace("@", "↧").replace("^", "φ")
          }}
        </span>
        <span style="display: inline-block" v-else>
          <span style="display: inline-block; text-align: right">
            {{
              ["①", "②", "③", "④", "⑤", "⑥", "⑦", "⑧", "⑨", "⑩", "⑪", "⑫"][
                idx
              ] + req.split(/[+|-]/)[0]
            }}
          </span>
          <span style="position: relative; width: 50px; display: inline-block">
            <sup
              style="
                position: absolute;
                left: -2px;
                bottom: 5px;
                width: 40px;
                display: inline-block;
                line-height: 10px;
                text-align: left;
                font-size: 10px;
                transform: scale(0.8);
              "
              >{{
                req.match(/[+|-]/)[0] + req.split(/[+|-]/)[1].split("/")[0]
              }}</sup
            >
            <sub
              style="
                position: absolute;
                left: 0px;
                top: -5px;
                width: 40px;
                display: inline-block;
                line-height: 10px;
                text-align: left;
                font-size: 10px;
                transform: scale(0.8);
              "
              >{{ req.match(/\/(.)/)[1] + req.split(/[+|-]/)[2] }}</sub
            >
          </span>
        </span>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data () {
    return {
      carouselList: []
    }
  },
  methods: {}
}
</script>

<style></style>
